import * as React from 'react';
import { DropdownOption } from '../classes/dropdownOptions';


export interface DropdownProps {
    selected?: string;
    onChange?: (newValue: string) => void;
    options: Array<DropdownOption>;
    name: string;
}

const Dropdown: React.SFC<DropdownProps> = (props) => {
    const onChangeFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        props.onChange(e.currentTarget.value);
    }

    const dropdownId = `${props.name}-dropdown-js`;
    return (
        <div className="calendar-filter-category">
            <label htmlFor={dropdownId}>{props.name}</label>
            <div className="calendar-filter-options">
              <select id={dropdownId} value={props.selected ? props.selected : ''} onChange={onChangeFunc.bind(this)}>
                {
                  props.options.map(option => <option key={`${option.text + option.value}`} value={option.value}>{option.text}</option>)
                }
              </select>
            </div>
        </div>
    );
}

export default Dropdown;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/dropdown.tsx